import { render, staticRenderFns } from "./DispatchStage.vue?vue&type=template&id=8c19be5c&scoped=true"
import script from "./DispatchStage.vue?vue&type=script&lang=js"
export * from "./DispatchStage.vue?vue&type=script&lang=js"
import style0 from "./DispatchStage.vue?vue&type=style&index=0&id=8c19be5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c19be5c",
  null
  
)

export default component.exports